import { o_global } from "../../common/namespaces";
import { assignNamespace } from "../../common/namespace-utils";
import { defineStore } from "../../common/nexus";
import { Hybrid, hybrid } from "./body/hybrid";
import { Orientation, orientation } from "./body/orientation";
import { isTouchable } from "./body/touch";
import * as screen from "./body/screen.js";
import { os, OsType } from "./body/os";
import { Browser, browser } from "./body/browser";
import { DeviceType, type } from "./body/type";
import type { DevicePointerType } from ".";

export * from "./body/browser";
export type * from "./body/events";
export * from "./body/hybrid";
export * from "./body/orientation";
export * from "./body/os";
export * as screen from "./body/screen";
export * from "./body/touch";
export * from "./body/type";

/**
 *
 */
export type GlobalDevice = {
  os: `${OsType}`;
  browser: `${Browser}`;
  /*                                */
  orientation: Orientation;
  /*                                */
  hybrid: Hybrid;
  type: `${DeviceType}`;
};

const device = assignNamespace(
  o_global,
  "device",
  {
    os: os(),
    browser: browser(),
    orientation: orientation(),
    hybrid: undefined as unknown as Hybrid,
    type: type(),
  },
  {
    Hybrid,
    Orientation,
    isTouchable: isTouchable(),
    screen,
    breakpoint: o_global.breakpoint,
  },
);

/*                                          */
device.hybrid = hybrid();

otto.device.assignNamespace({
  pointerType: defineStore<DevicePointerType | undefined>({
    isTouchable: isTouchable(),
    isHybrid: device.hybrid.isHybrid,
  }),
  getPointerType: () => otto.device.pointerType.get() ?? { isTouchable: false, isHybrid: false },
  getScreenSpecs: () => ({
    width: screen.getWidth(),
    height: screen.getHeight(),
    pixelRatio: screen.getDevicePixelRatio(),
  }),
});
